import { selectEditorPreviewWidgetComponentProps, selectEditorSettingsColumnsOptions, selectEditorSettingsUserSettings } from "../draft-selectors";
import { updateOrAddManyColumnTemplates } from "./columnsTemplateStateHelper";
import { updateOrAddDatapointRequests } from "./datapointRequestStateHelper";
import { componentPropsPatcher } from "store/current-dashboard/types";
export const removeComponentPropsPatcherAddSelectedGroupByColumns = (state) => {
    const componentProps = selectEditorPreviewWidgetComponentProps(state);
    if (!componentProps) {
        return;
    }
    const componentPropsPatchers = componentProps?.componentPropsPatchers;
    if (!componentPropsPatchers) {
        return;
    }
    const patcherIndex = componentPropsPatchers.findIndex((d) => d.patcher === componentPropsPatcher.addSelectedGroupByColumns) ?? -1;
    if (patcherIndex !== -1) {
        componentPropsPatchers.splice(patcherIndex, 1);
    }
};
export const updateEditorPreviewWidgetComponentProps = (state) => {
    const previewWidgetComponentProps = selectEditorPreviewWidgetComponentProps(state);
    if (previewWidgetComponentProps) {
        const columnsOptions = selectEditorSettingsColumnsOptions(state) || [];
        updateOrAddManyColumnTemplates(state, columnsOptions);
        updateOrAddDatapointRequests(state, columnsOptions);
    }
};
export const updateUserSettingsInPreviewComponentProps = (state) => {
    const previewWidgetComponentProps = selectEditorPreviewWidgetComponentProps(state);
    const userSettings = selectEditorSettingsUserSettings(state);
    previewWidgetComponentProps.userSettings = { ...previewWidgetComponentProps.userSettings, ...userSettings };
};
